import { Controller } from "@hotwired/stimulus";

const parameterize = function (str1) {
  // Trim leading and trailing whitespace, convert to lowercase, and replace non-alphanumeric characters with an empty string
  return str1
    .trim()
    .toLowerCase()
    .replace(/[^a-zA-Z0-9 -]/, "")
    .replace(/\s/g, "-");
};

// Connects to data-controller="create-event"
export default class extends Controller {
  static targets = ["editLink", "titleInput", "slug"];
  connect() {}

  setSlug() {
    const slug = parameterize(this.titleInputTarget.value);
    const url = new URL(this.editLinkTarget.href);
    url.searchParams.set("slug", slug);
    this.editLinkTarget.href = url.toString();
    this.slugTarget.innerText = slug;
  }
}
